// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 707 ? "6284d963" : chunkId) + "." + {"488":"ea0ad45ba5f1efe1","658":"781ea00e821144af","707":"fb655fbba3483474","754":"9911b1e90f154a82"}[chunkId] + ".js";
};